import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { TranslateModule } from '@ngx-translate/core';
import IJob from '../../../_interfaces/IJob';
import { AdminEntityLoaderService } from '../../../_services/admin/admin-entity-loader.service';
import { AdminFormLayoutComponent } from '../../../components/admin-ui/admin-form-layout/admin-form-layout.component';
import { AdminPageHeaderComponent } from '../../../components/admin-ui/admin-page-header/admin-page-header.component';
import { AdminStatePanelComponent } from '../../../components/admin-ui/admin-state-panel/admin-state-panel.component';
import { FormJobComponent } from '../../../components/forms/form-job/form-job.component';

@Component({
  selector: 'app-admin-job-detail',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AdminPageHeaderComponent,
    AdminStatePanelComponent,
    AdminFormLayoutComponent,
    FormJobComponent,
  ],
  templateUrl: './admin-job-detail.component.html',
  styleUrl: './admin-job-detail.component.scss',
})
export class AdminJobDetailComponent implements OnInit {
  public customersId = 0;
  public jobsId = 0;
  public job: IJob | null = null;
  public loading = true;
  public hasError = false;
  readonly reload = (): void => this.load();

  constructor(
    private readonly route: ActivatedRoute,
    private readonly loader: AdminEntityLoaderService,
  ) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'jobs',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
    this.jobsId = readRouteParam(this.route, 'jobs_id');
    this.load(true);
  }

  load(fromResolver = false): void {
    this.loading = true;
    this.hasError = false;

    if (fromResolver) {
      const job = (this.route.snapshot.data['job'] || null) as IJob | null;
      if (job) {
        this.job = job;
        this.loading = false;
        return;
      }
    }

    this.loader.loadJob(this.customersId, this.jobsId).subscribe({
      next: (job) => {
        this.job = job;
        this.hasError = !job;
        this.loading = false;
      },
      error: () => {
        this.hasError = true;
        this.loading = false;
      },
    });
  }
}
